/** @jsx React.DOM */

var React = require('react');
var _ = require('lodash');

require('./Stats.less');

var Stats = React.createClass({displayName: 'Stats',
  render: function() {
    var data = this.props.data;
    return (
      React.DOM.div({className: "Stats"}, 
        this.renderCount(data), 
        this.renderAverage(data)
      )
    );
  },

  renderCount: function(data) {
    return (
      React.DOM.div({className: "Stats-item"}, 
        'Count: ', React.DOM.strong(null, data.length)
      )
    );
  },

  renderAverage: function(data) {
    var avg;
    var n = data.length;
    if (!n) {
      avg = '-';
    }
    else {
      var sum = _.reduce(data, function(sum, d) {
        return sum + d.z;
      }, 0);
      avg = Math.round(sum/n * 10)/10;
    }
    return (
      React.DOM.div({className: "Stats-item"}, 
        'Average size: ', React.DOM.strong(null, avg)
      )
    );
  }
});

module.exports = Stats;



/*****************
 ** WEBPACK FOOTER
 ** ./src/Stats.js
 ** module id = 5
 ** module chunks = 0
 **/